export default {
      id: "dashboards-usage",
      viewBox: "0 0 27.711 27.711",
      url: __webpack_public_path__ + "img/icons.0fe16570.svg#dashboards-usage",
      toString: function () {
        return this.url;
      }
    }